<template>
    <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg5 xl5 class="pa-2 mr-2">
            <h2>Geslo za prijavo</h2>
            <empty-space />
            <change-password />
        </v-flex>
        <v-flex xs12 sm12 md12 lg5 xl5 class="pa-2">
            <h2>Prijavljene seje</h2>
            <empty-space />
            <active-login-sessions />
        </v-flex>
    </v-layout>
</template>

<script>
    import ChangePassword from "./embeded-views/ChangePassword"
    import ActiveLoginSessions from "./embeded-views/ActiveLoginSessions"
    import EmptySpace from "../EmptySpace";
    import utils from "../../store/utils";

    export default {
        name: "SecurityTab",
        components: {EmptySpace, ChangePassword, ActiveLoginSessions},
        computed: {
            connected_account_is_temp: utils.vuexBuildSetGet(this, 'profile', 'user.connected_account_is_temp'),
            card_number: utils.vuexBuildSetGet(this, 'profile', 'user.card'),
            name: utils.vuexBuildSetGet(this, 'profile', 'user.personal.name'),
            lastname: utils.vuexBuildSetGet(this, 'profile', 'user.personal.surname'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.email'),
            mobileNo: utils.vuexBuildSetGet(this, 'profile', 'user.personal.mobileNo'),
        }
    }
</script>

<style scoped>
    @import "../../styles/variables.less";

    .foreword {
        font-style: italic;
    }

    .user-info p{
        padding: 5px;
        margin-bottom: 0px;
        font-weight: bold;
        border-top: 1px solid #c1c1c1;
    }

    .user-info p:last-child{
        border-bottom: 1px solid #c1c1c1;
    }
    .user-info label{
        font-weight: normal;
        width: 250px;
        display: inline-block;
    }

</style>